import MentoringNumber from './MentoringNumber.vue';

export default MentoringNumber;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/process/components/number/index.ts